import { render, staticRenderFns } from "./ConfirmationPatientPortal.vue?vue&type=template&id=4371ae9f&"
import script from "./ConfirmationPatientPortal.vue?vue&type=script&lang=js&"
export * from "./ConfirmationPatientPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports